function cleanUpCollectionTitle(title) {
    return title
        .toLowerCase()
        .replace(/^men's|^men|^women's|^women/, '')
        .trim();
}
function getCollectionData(firstCollection, maxTier) {
    var collectionCollections = document.querySelectorAll('[data-collections][data-tier]');
    var productCollections = document.querySelector('[data-product-collections]');
    var collectionsProductIsPartOf = JSON.parse(productCollections === null || productCollections === void 0 ? void 0 : productCollections.dataset.productCollections).map(function (collection) { return collection.handle; });
    var collectionJSON = Array.from(collectionCollections).map(function (group) {
        return {
            tier: parseInt(group.dataset.tier),
            collections: JSON.parse(group.dataset.collections).filter(function (collection) {
                return collectionsProductIsPartOf.includes(collection.handle);
            }),
        };
    });
    return collectionJSON
        .map(function (collectionWrapper) {
        var match = collectionWrapper.collections.find(function (coll) { return coll.handle === firstCollection; });
        if (match && collectionWrapper.tier <= maxTier)
            return { tier: collectionWrapper.tier, collection: match };
    })
        .filter(function (i) { return i; })
        .pop();
}
function handleUnisex(_a) {
    var _b;
    var crumbElement = _a.crumbElement, collectionsList = _a.collectionsList;
    var firstCollection = collectionsList
        .filter(function (collection) {
        return collection !== '/collections/all' && '/collections/accessories-all';
    })
        .pop()
        .replace('/collections/', '');
    if (firstCollection) {
        var linkClone = crumbElement.cloneNode();
        var caretClone = (_b = crumbElement.parentNode
            .querySelector('[data-macade-breadcrumb-caret]')) === null || _b === void 0 ? void 0 : _b.cloneNode(true);
        var firstCollectionData = getCollectionData(firstCollection, 3);
        function unisexLink(link, sex) {
            return link.replace(/accessories-all|collections-all/, "".concat(sex, "-accessories"));
        }
        if (firstCollection.includes('women')) {
            linkClone.textContent = 'women';
            linkClone.href = unisexLink(crumbElement.href, 'women');
            crumbElement.textContent = cleanUpCollectionTitle(firstCollectionData === null || firstCollectionData === void 0 ? void 0 : firstCollectionData.collection.title);
            crumbElement.href =
                '/collections/' + (firstCollectionData === null || firstCollectionData === void 0 ? void 0 : firstCollectionData.collection.handle);
            crumbElement.parentNode.insertBefore(linkClone, crumbElement);
            crumbElement.parentNode.insertBefore(caretClone, crumbElement);
        }
        else if (firstCollection.includes('men-')) {
            linkClone.textContent = 'men';
            linkClone.href = unisexLink(crumbElement.href, 'men');
            crumbElement.textContent = cleanUpCollectionTitle(firstCollectionData === null || firstCollectionData === void 0 ? void 0 : firstCollectionData.collection.title);
            crumbElement.href =
                '/collections/' + (firstCollectionData === null || firstCollectionData === void 0 ? void 0 : firstCollectionData.collection.handle);
            crumbElement.parentNode.insertBefore(linkClone, crumbElement);
            crumbElement.parentNode.insertBefore(caretClone, crumbElement);
        }
    }
}
document.addEventListener('DOMContentLoaded', function () {
    var crumbElements = document.querySelectorAll('[data-macade-breadcrumb]');
    try {
        var breadcrumbPath = JSON.parse(localStorage.getItem('breadcrumbPath') || '[]');
        var collectionsList = breadcrumbPath.filter(function (crumb) {
            return crumb.startsWith('/collections/');
        });
        if (crumbElements.length === 1) {
            handleUnisex({ crumbElement: crumbElements[0], collectionsList: collectionsList });
        }
        else if (collectionsList.length) {
            var firstCollection = collectionsList
                .pop()
                .replace('/collections/', '');
            var collectionData_1 = [];
            var firstCollectionData = getCollectionData(firstCollection, 3);
            if (firstCollectionData)
                collectionData_1.push(firstCollectionData);
            if (collectionsList.length && (firstCollectionData === null || firstCollectionData === void 0 ? void 0 : firstCollectionData.tier) > 1) {
                var secondCollection = collectionsList
                    .pop()
                    .replace('/collections/', '');
                var secondCollectionData = getCollectionData(secondCollection, (firstCollectionData === null || firstCollectionData === void 0 ? void 0 : firstCollectionData.tier) - 1);
                if (secondCollectionData)
                    collectionData_1.push(secondCollectionData);
                if (collectionsList.length && (secondCollectionData === null || secondCollectionData === void 0 ? void 0 : secondCollectionData.tier) > 1) {
                    var thirdCollection = collectionsList
                        .pop()
                        .replace('/collections/', '');
                    var thirdCollectionData = getCollectionData(thirdCollection, (secondCollectionData === null || secondCollectionData === void 0 ? void 0 : secondCollectionData.tier) - 1);
                    if (thirdCollectionData)
                        collectionData_1.push(thirdCollectionData);
                }
            }
            if (collectionData_1.length) {
                // Check if the latest visited page is tier 2
                var latestVisitedIsTier2 = collectionData_1.some(function (coll) { return coll.tier === 2; });
                if (latestVisitedIsTier2) {
                    collectionData_1.sort(function (a, b) { return b.tier - a.tier; });
                    collectionData_1.forEach(function (coll) {
                        var link = document.querySelector(".macade-breadcrumbs a[data-tier=\"".concat(coll.tier, "\"]"));
                        if (link) {
                            if (coll.tier === 1 && collectionData_1.length !== 1) {
                                link.innerHTML = coll.collection.title
                                    .toLowerCase()
                                    .replace('latest', '')
                                    .trim();
                            }
                            else {
                                link.innerHTML = cleanUpCollectionTitle(coll.collection.title);
                            }
                            link.href = '/collections/' + coll.collection.handle;
                            link.dataset.history = 'true';
                            var caret = document.querySelector(".macade-breadcrumbs span[data-tier=\"".concat(coll.tier, "\"]"));
                            if (caret) {
                                caret.dataset.history = 'true';
                            }
                        }
                    });
                    var toRemove = document.querySelectorAll(".macade-breadcrumbs [data-tier]:not([data-history])");
                    toRemove.forEach(function (entry) { return entry.remove(); });
                }
            }
        }
    }
    catch (error) {
        console.error('error parsing collecion data', error);
    }
});
